import { currencyApi } from "api/TenantSlug/Currency/api.ts";

export const composeCurrencyQueryOptions = (currencyId: string) => {
    return {
        queryKey: ["getCurrencies", currencyId],
        queryFn: () => currencyApi.show(currencyId),
    };
};

export const getCurrencyQueryOptions = (currencyId: string) => {
    return {
        ...composeCurrencyQueryOptions(currencyId),
        suspense: true,
    };
};
